import React from "react";
import { createGlobalStyle } from "styled-components";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const PageLoading = () => {
  const FullLoadingStyle = createGlobalStyle`
    .MuiBackdrop-root {
      background-color: rgba(255, 255, 255, 0.5);
      z-index: 99999;
    }
    .spinner {
      color: #1E243E;
    }
  `;

  return (
    <>
      <FullLoadingStyle />
      <Backdrop className="backdrop" open={true}>
        <CircularProgress className="spinner" size={50} />
      </Backdrop>
    </>
  );
};

export default PageLoading;